<script lang="ts" setup></script>

<template>
  <div class="charts-widget">
    <div class="charts-widget__header">
      <h2>ESEA Kenya Reports</h2>
      <span>Data gathered: Feb 12, 2024 - Aug 24, 2024</span>
    </div>
    <div class="charts-widget__content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.charts-widget {
  padding: 32px 0;

  &__header {
    padding: 0 32px 32px 32px;
  }

  &__header h2 {
    font-size: 22px;
    font-weight: 500;
    color: #272740;
  }

  &__header span {
    font-size: 16px;
    font-weight: 400;
    color: #8b8fa1;
  }
}
</style>
